import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Simran
 * id 6773EDAB-CBAA-4C56-80D6-E029EB45115E
 * name step-forward
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/step-forward.svg
 * tags
 */
export const StepForwardIcon = createSvgIcon(<><path d="M5,5V19H8V5M10,5V19L21,12" /></>, 'StepForwardIcon');
export default StepForwardIcon